import { FieldTypes } from '../../../../../components/FormBuilder';

export const currentLimit = {
  type: 'text',
  inputMode: 'text',
  placeholder: 'Current Limit',
  name: 'currentLimit',
  disabled: true,
  dark: false,
  hideUnderline: true
};
export const limit = {
  type: 'text',
  inputMode: 'text',
  placeholder: 'How much do you need?',
  name: 'limit',
  disabled: false,
  dark: false,
  hideUnderline: true
};
export const newLimit = {
  type: 'text',
  inputMode: 'text',
  placeholder: 'New limit',
  name: 'newLimit',
  disabled: true,
  dark: false,
  hideUnderline: true
};

export const formFields = [
  {
    type: FieldTypes.INPUT,
    props: currentLimit
  },
  {
    type: FieldTypes.CURRENCYINPUT,
    props: limit
  },
  {
    type: FieldTypes.INPUT,
    props: newLimit
  }
];